<div class="fp-body">
    <div class="fp-overlay" aria-hidden="true"></div>

    <div class="fp-logo">
        <img alt="Megaprofer S.A." src="assets/images/logo-mega.png">
    </div>

    <div class="fp-card">
        <div class="fp-head">
            <img class="fp-hq" alt="HQ" src="assets/images/logo-hq.png">
            <span class="fp-system">Sistema Centralizado</span>
        </div>

        <div class="fp-content fp-center">
            <div class="fp-state-icon"><i class="pi pi-clock" aria-hidden="true"></i></div>
            <h3>Tu enlace ha expirado</h3>
            <p class="fp-desc">
                Por seguridad, los enlaces para restablecer la contraseña son válidos solo por
                10 minutos. Solicita uno nuevo para continuar.
            </p>
            <a class="fp-submit" routerLink="/forgot-password">
                <i class="pi pi-refresh"></i> Solicitar nuevo enlace
            </a>
            <a class="fp-back" routerLink="/login">
                <i class="pi pi-arrow-left"></i> Volver a iniciar sesión
            </a>
        </div>
    </div>

    <div class="fp-legal">© {{ year }} Megaprofer S.A. · Todos los derechos reservados</div>
</div>
